export enum RetentionTimePeriod {
  DAY = 'day',
  WEEK = 'week',
}

export enum RetentionFilterKey {
  ANONYMOUS_ID = 'anonymous_id',
  ADDRESS = 'address',
}
